<template>
  <div>
    <vue-dropzone :id="'excelFile_' + index" ref="myDropzone" :options="dropzoneOptions"></vue-dropzone>
    <div v-if="uploadedFile">
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import * as XLSX from 'xlsx';
export default {
  data() {
    return {
      index: 0,
      questionData: {
        in_question_type_id: null,
        validationDetails: {},
        imageArray: [],
        sessionData: null
      },
      dropzoneOptions: {
        url: '/',
        method: "GET",
        maxFiles: 1,
        uploadMultiple: false,
        acceptedFiles: '.xlsx',
        addRemoveLinks: true,
        dictDefaultMessage: "<strong class='dz-message'>Drop your Excel file here or click to upload</strong>",
      },
      uploadedFile: null,
      excelDataArray: null,
      stAnswerTextList: [],
      stAnswerTextListValidate: [],
      newAnswers: []
    };
  },
  mounted() {
    this.initDropzone();
  },
  computed: {
    ...mapGetters("editquestionEdit", ["getSurveyQuestWithDetails", "ExcelQuestionMasterId"]),
  },
  watch: {
    // Watch for changes in the question ID
    ExcelQuestionMasterId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.initializeQuestionData();
        }
      }
    }
  },
  methods: {
    ...mapActions("editquestionEdit", ["setExcelDataArray", "addTagsDetails", "getQuestionAll"]),
    
    initializeQuestionData() {
      const surveyData = this.getSurveyQuestWithDetails;
      if (!surveyData || !this.ExcelQuestionMasterId || !surveyData[this.ExcelQuestionMasterId]) {
        return;
      }

      const filterExcelData = surveyData[this.ExcelQuestionMasterId];
      
      // Initialize question data based on the type
      if (filterExcelData.qval_6) {
        this.questionData.in_question_type_id = filterExcelData.qval_6.in_question_type_id;
      } else if (filterExcelData.qval_14) {
        this.questionData.in_question_type_id = filterExcelData.qval_14.in_question_type_id;
      }
    },

    initDropzone() {
      // Get a reference to the Dropzone instance
      const myDropzone = this.$refs.myDropzone.dropzone;

      myDropzone.on('addedfile', (file) => {
        const reader = new FileReader();
        reader.onload = () => {
          const fileContent = reader.result;
          this.parseExcelFile(fileContent);
        };
        reader.readAsBinaryString(file);
      });
    },

    parseExcelFile(fileContent) {
      try {
        // Parse Excel file
        const workbook = XLSX.read(fileContent, { type: 'binary' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { defval: null });
        
        // Get answers from Excel file with their positions
        const answersWithPositions = excelData
          .map((row, index) => ({
            position: index,
            answer: row.Answers ? row.Answers.toString().trim() : null
          }))
          .filter(item => item.answer); // Remove empty answers

        if (answersWithPositions.length === 0) {
          this.$awn.alert("No valid answers found in Excel file. Please check that your file has an 'Answers' column.");
          return;
        }

        // Emit answers with positions to parent
        this.$emit('new-answers', answersWithPositions);
        
        // Clear the dropzone
        this.$refs.myDropzone.dropzone.removeAllFiles();
      } catch (error) {
        console.error('Error processing Excel file:', error);
        this.$awn.alert("Error processing the Excel file. Please check the file format and try again.");
      }
    },

    // New method to get current answers including new ones
    getAllAnswers() {
      return [...this.stAnswerTextList, ...this.newAnswers];
    }
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/Dashboard/RightBarComponents/ExcelFileDropzone.vue